import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import {
    mapData,
    converTime,
    getPickupHours,
} from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommonContext from '@/product/context/common/commonContext'
import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/custom/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import moment from 'moment'

const LocationManage = (props) => {
    const settingcontext = useContext(SettingContext)
    const usercommoncontext = useContext(UserCommonContext)
    const commonContext = useContext(CommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { USStates, allCountries, allStates, allCounties, getAllCounties } =
        commonContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        searchTableFetch,
        searchTableAction,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext
    const [parkingSlot, setParkingSlot] = useState([])
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const data = props.data
    const toggleFullScreenPopup = props.function

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            active: 0,
            id: 0,
            table: 'cigars',
            updateCigar: true,
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive' ||
                dataValue.action === 'delete'
            ) {
                dataValue.active =
                    dataValue.action === 'delete'
                        ? 2
                        : dataValue.action === 'active'
                        ? 1
                        : 0
                delete dataValue.action

                searchTableAction(values)
            }
        },
    })
    const validationArray = Yup.object({
        Maker: Yup.string().required('Required!'),
        MakerCountry: Yup.string().required('Required!'),
        CigarCountry: Yup.string().required('Required!'),
        Marca: Yup.string().required('Required!'),
        YearMarcaCreated: Yup.string().required('Required!'),
        YearMarcaDiscontinued: Yup.string().required('Required!'),
        VitoladeSalida: Yup.string().required('Required!'),
        VitoladeGalera: Yup.string().required('Required!'),
        CommonSizeName: Yup.string().required('Required!'),
        RingGauge: Yup.string().required('Required!'),
        Length: Yup.string().required('Required!'),
        MachineMade: Yup.string().required('Required!'),
        Packaging: Yup.string().required('Required!'),
        Bands: Yup.string().required('Required!'),
        // Tubes: Yup.string().required('Required!'),
        // YearPackagingDiscontinued: Yup.string().required('Required!'),
        YearVitolaCreated: Yup.string().required('Required!'),
        // Description: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            Maker: '',
            MakerCountry: '',
            CigarCountry: '',
            Marca: '',
            YearMarcaCreated: '',
            YearMarcaDiscontinued: '',
            VitoladeSalida: '',
            VitoladeGalera: '',
            CommonSizeName: '',
            RingGauge: '',
            Length: '',
            MachineMade: '',
            Packaging: '',
            Description: '',
            Bands: '',
            Tubes: '',
            YearPackagingDiscontinued: '',
            YearVitolaCreated: '',
            YearCigarDiscontinued: '',
            Region: '',
            NumberofBoxesMade: '',
            TypeRelease: '',
            SpecialReleaseName: '',
            First_Year_Of_Seal_UV: '',
            // HighlightToAdmin: '',
            YearEnd: '',
            YearStart: '',
            NumberOfCigarsInBox: '',
            AllowRecent: 'No',
            Serial_Number_Check: '',
            HSA: '',
            DescriptionHSA: '',
            updateCigar: true,
            status: 'active',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (data.status == 'duplicate') values.id = 0
            values.table = 'cigars'
            values.updateCigar = true

            Object.keys(values).forEach((key) => {
                if (typeof values[key] === 'string')
                    values[key] = values[key].trim()
            })

            searchTableAction(values, false, 'cigar_create')
        },
    })

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'cigar_create' &&
                responseStatusSetting.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                formik.resetForm()
            }
        }
    }, [responseStatusSetting])

    useEffect(() => {
        if (data.status != 'new') {
            formik.setFieldValue('id', data.id)
            const template =
                props?.record?.find((cat) => cat.id === data.id) || {}

            formik.setValues({
                ...formik.values,
                ...template,
            })
        } else {
            resetFrom()
        }
    }, [data])

    const resetFrom = () => {
        formik.setValues({
            id: 0,
            Maker: '',
            MakerCountry: '',
            CigarCountry: '',
            Marca: '',
            YearMarcaCreated: '',
            YearMarcaDiscontinued: '',
            VitoladeSalida: '',
            VitoladeGalera: '',
            CommonSizeName: '',
            RingGauge: '',
            Length: '',
            MachineMade: '',
            Packaging: '',
            Description: '',
            Bands: '',
            Tubes: '',
            YearPackagingDiscontinued: '',
            YearVitolaCreated: '',
            YearCigarDiscontinued: '',
            Region: '',
            NumberofBoxesMade: '',
            TypeRelease: '',
            SpecialReleaseName: '',
            First_Year_Of_Seal_UV: '',
            // HighlightToAdmin: '',
            YearEnd: '',
            YearStart: '',
            NumberOfCigarsInBox: '',
            AllowRecent: 'No',
            Serial_Number_Check: '',
            HSA: '',
            DescriptionHSA: '',
        })
    }

    const details = {
        formik: formik,
        data: [
            {
                label: 'Maker',
                placeholder: 'Enter Maker',
                type: '',
                required: true,
                class: 'col-6',
                name: 'Maker',
            },
            {
                label: 'Origin',
                placeholder: 'Enter Origin',
                type: '',
                class: 'col-6',
                name: 'MakerCountry',
            },
            {
                label: 'CigarCountry',
                placeholder: 'Enter CigarCountry',
                type: '',
                class: 'col-6',
                name: 'CigarCountry',
            },
            {
                label: 'Marca',
                placeholder: 'Enter Marca',
                type: '',
                class: 'col-6',
                name: 'Marca',
            },
            {
                label: 'YearMarcaCreated',
                placeholder: 'Enter YearMarcaCreated',
                type: '',
                class: 'col-6',
                name: 'YearMarcaCreated',
            },
            {
                label: 'YearMarcaDiscontinued',
                placeholder: 'Enter YearMarcaDiscontinued',
                type: '',
                class: 'col-6',
                name: 'YearMarcaDiscontinued',
            },
            {
                label: 'VitoladeSalida',
                placeholder: 'Enter VitoladeSalida',
                type: '',
                class: 'col-6',
                name: 'VitoladeSalida',
            },
            {
                label: 'VitoladeGalera',
                placeholder: 'Enter VitoladeGalera',
                type: '',
                class: 'col-6',
                name: 'VitoladeGalera',
            },
            {
                label: 'CommonSizeName',
                placeholder: 'Enter CommonSizeName',
                type: '',
                class: 'col-6',
                name: 'CommonSizeName',
            },
            {
                label: 'RingGauge',
                placeholder: 'Enter RingGauge',
                type: '',
                class: 'col-6',
                name: 'RingGauge',
            },
            {
                label: 'Length',
                placeholder: 'Enter Length',
                type: '',
                class: 'col-6',
                name: 'Length',
            },
            {
                label: 'MachineMade',
                placeholder: 'Enter MachineMade',
                type: '',
                class: 'col-6',
                name: 'MachineMade',
            },
            {
                label: 'Packaging',
                placeholder: 'Enter Packaging',
                type: '',
                class: 'col-6',
                name: 'Packaging',
            },
            {
                label: 'Bands',
                placeholder: 'Enter Bands',
                type: '',
                class: 'col-6',
                name: 'Bands',
            },
            {
                label: 'Tubes',
                placeholder: 'Enter Tubes',
                type: '',
                class: 'col-6',
                name: 'Tubes',
            },
            {
                label: 'YearPackagingDiscontinued',
                placeholder: 'Enter YearPackagingDiscontinued',
                type: '',
                class: 'col-6',
                name: 'YearPackagingDiscontinued',
            },
            {
                label: 'YearVitolaCreated',
                placeholder: 'Enter YearVitolaCreated',
                type: '',
                class: 'col-6',
                name: 'YearVitolaCreated',
            },
            {
                label: 'YearCigarDiscontinued',
                placeholder: 'Enter YearCigarDiscontinued',
                type: '',
                class: 'col-6',
                name: 'YearCigarDiscontinued',
            },
            {
                label: 'Region',
                placeholder: 'Enter Region',
                type: '',
                class: 'col-6',
                name: 'Region',
            },
            {
                label: 'NumberofBoxesMade',
                placeholder: 'Enter NumberofBoxesMade',
                type: 'number',
                class: 'col-6',
                name: 'NumberofBoxesMade',
            },

            {
                label: 'TypeRelease',
                placeholder: 'Enter TypeRelease',
                type: '',
                class: 'col-6',
                name: 'TypeRelease',
            },
            {
                label: 'SpecialReleaseName',
                placeholder: 'Enter SpecialReleaseName',
                type: '',
                class: 'col-6',
                name: 'SpecialReleaseName',
            },
            {
                label: 'First Year Of Seal UV',
                placeholder: 'Enter First Year Of Seal UV',
                type: 'number',
                class: 'col-6',
                name: 'First_Year_Of_Seal_UV',
            },
            // {
            //     label: 'HighlightToAdmin',
            //     placeholder: 'Enter HighlightToAdmin',
            //     type: '',
            //     class: 'col-6',
            //     name: 'HighlightToAdmin',
            // },
            {
                label: 'YearEnd',
                placeholder: 'Enter YearEnd',
                type: '',
                class: 'col-6',
                name: 'YearEnd',
            },
            {
                label: 'YearStart',
                placeholder: 'Enter YearStart',
                type: '',
                class: 'col-6',
                name: 'YearStart',
            },
            {
                label: 'NumberOfCigarsInBox',
                placeholder: 'Enter NumberOfCigarsInBox',
                type: '',
                class: 'col-6',
                name: 'NumberOfCigarsInBox',
            },
            {
                label: 'AllowRecent',
                placeholder: 'Enter AllowRecent',
                type: 'select',
                options: [
                    {
                        show: 'Yes',
                        value: 'Yes',
                    },
                    {
                        show: 'No',
                        value: 'No',
                    },
                ],
                class: 'col-6',
                name: 'AllowRecent',
            },

            {
                label: 'Serial Number Check',
                placeholder: 'Enter Serial Number Check',
                type: 'select',
                options: [
                    {
                        show: 'Yes',
                        value: 1,
                    },
                    {
                        show: 'No',
                        value: 0,
                    },
                ],
                class: 'col-6',
                name: 'Serial_Number_Check',
            },
            {
                label: 'Description',
                placeholder: 'Enter Description',
                type: '',
                class: 'col-6',
                name: 'Description',
            },
            {
                field: 'HSA',
                name: 'HSA',
                type: '',
                placeholder: 'Enter HSA',

                label: 'HSA',

                class: 'col-6',
            },
            {
                field: 'DescriptionHSA',
                name: 'DescriptionHSA',
                type: '',
                placeholder: 'Enter Description',

                label: 'Description HSA',

                class: 'col-6',
            },
        ],
    }

    const submitFunction = () => {
        formik.handleSubmit()
        //toggleFullScreenPopup(false)
    }
    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'Add New Cigar'
                    : data.status === 'edit'
                    ? 'Edit Cigar'
                    : 'Duplicate Cigar'
            }
            open={data.popup}
            handleClose={() => {
                toggleFullScreenPopup(false, 'new', 0)
                formik.resetForm()
            }}
        >
            <div className="dashboard addNewListing mt-4">
                <div className="fspBody">
                    {/* <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        > */}
                    <div className="row">{mapData(details)}</div>

                    <div className="actionButton d-flex justify-content-center align-items-center">
                        <SecondaryButton
                            id="location_cancel"
                            label="Cancel"
                            onClick={() => {
                                toggleFullScreenPopup(false)
                                formik.resetForm()
                            }}
                        />
                        <PrimaryButton
                            id="location_submit"
                            label="Submit"
                            onClick={submitFunction}
                        />
                    </div>
                    {/* </form> */}
                </div>
            </div>
        </FullScreenPopup>
    )
}
export default LocationManage
